export default __webpack_public_path__ + "static/media/wp1810641-mr-robot-wallpapers.d319d6ec.svg";